import React from "react";
import "./Skills.css";
import htmlLogo from "../../assets/icons8-html-60.png";
import cssLogo from "../../assets/icons8-css-60.png";
import javascriptLogo from "../../assets/icons8-javascript-60.png";
import tailwindLogo from "../../assets/icons8-tailwind-css-60.png"; // Adjust the filename accordingly
import reactLogo from "../../assets/icon8-react.png";
import nodeLogo from "../../assets/icons8-node-js-60.png";
import mongoLogo from "../../assets/icons8-mongo-db-60.png";
import mysqlLogo from "../../assets/icons8-mysql-60.png";
import pythonLogo from "../../assets/icons8-python-60.png";
import javaLogo from "../../assets/icons8-java-60.png";

const Skills = () => {
    return(
        <div className="container-skills">
            <div className="description">
                <h1>My Skills</h1>
                <p>
                I possess a strong foundation in full-stack development, with expertise in JavaScript, Python, Ruby, C++, and Java, as well as database management using MySQL, Microsoft SQL Server, Firestore and MongoDB. My skills span mobile and web app development using React Native, React.js, Rails, Node.js, and Express.js, complemented by proficiency in HTML, CSS, and responsive design frameworks like Bootstrap and Tailwind. Additionally, I bring experience in cloud solutions like Firebase, AWS, and Vercel.
                </p>
            </div>
            <div className="tech-used">
                <div className="logos-skills">
                    <img src={htmlLogo} alt="HTML Logo" className="logo"/>
                    <img src={cssLogo} alt="CSS Logo" className="logo"/>
                    <img src={javascriptLogo} alt="JavaScript Logo" className="logo"/>
                    <img src={tailwindLogo} alt="Tailwind CSS Logo" className="logo"/>
                    <img src={reactLogo} alt="React Logo" className="logo"/>
                    <img src={nodeLogo} alt="Node.js Logo" className="logo"/>
                    <img src={mongoLogo} alt="MongoDB Logo" className="logo"/>
                    <img src={mysqlLogo} alt="MySQL Logo" className="logo"/>
                    <img src={pythonLogo} alt="Python Logo" className="logo"/>
                    <img src={javaLogo} alt="Java Logo" className="logo"/>
                </div>
            </div>
        </div>
    )
}

export default Skills;
